import React from 'react';

function Pricing() {
  return (
    <div className="container py-4 py-md-5 mb-5">
      <div className="row align-items-center">

        {/* Left Content */}
        <div className="col-12 col-md-5 mb-4 mb-md-0 text-center text-md-start">
          <h1 className="mb-3">Unbeatable pricing</h1>

          <p>
            We pioneered the concept of discount broking and price
            transparency in India. Flat fees and no hidden charges.
          </p>

          <a
            href="#"
            style={{ textDecoration: "none" }}
            className="d-inline-block mt-2"
          >
            See Pricing →
          </a>
        </div>

        {/* Right Pricing Cards */}
        <div className="col-12 col-md-7">
          <div className="row text-center">

            {/* Card 1 */}
            <div className="col-12 col-sm-6 mb-3">
              <div className="p-4 border h-100">
                <h1 className="mb-3">₹0</h1>
                <p>
                  Free equity delivery and <br />
                  direct mutual funds
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-sm-6 mb-3">
              <div className="p-4 border h-100">
                <h1 className="mb-3">₹20</h1>
                <p>Intraday and F&O</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default Pricing;